import type { ReactNode } from "react";

import type { DesignSystemElementProps, DesignSystemRef } from "@/design-system/contracts/dom";

export type DetailLayoutProps = {
  primary: ReactNode;
  metadata: ReactNode;
} & Omit<DesignSystemElementProps<"div">, "children"> &
  DesignSystemRef<HTMLDivElement>;

/** Responsive primary-content and metadata-rail layout for detail surfaces. */
export function DetailLayout({ primary, metadata, ref, ...nativeProps }: DetailLayoutProps): ReactNode {
  return (
    <div {...nativeProps} ref={ref} className="grid w-full grid-cols-12 gap-md @lg:gap-lg">
      <section className="col-span-full flex w-full flex-col gap-md @md:col-span-8">{primary}</section>
      <aside className="col-span-full flex w-full flex-col gap-md @md:col-span-4">{metadata}</aside>
    </div>
  );
}
